// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"15":"13a84e5f","75":"f55c9f9b"}[chunkId] + ".chunk.js";
};